import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./home.css";
import IntakeIcon from "../../assets/img/svg/xintakeicon.svg";
import ManifestCreationIcon from "../../assets/img/svg/xmanifestcreationicon.svg";
import ManifestAcceptanceIcon from "../../assets/img/svg/xmanifestacceptanceicon.svg";
import CuttingIcon from "../../assets/img/svg/xcuttingicon.svg";
import ScanningIcon from "../../assets/img/svg/xscanningicon.svg";
import QCIcon from "../../assets/img/svg/xqcicon.svg";
import StagedToClientIcon from "../../assets/img/svg/xstagedtoclienticon.svg";
import ClientIcon from "../../assets/img/svg/xclienticon.svg";
import ReadyToRecycleIcon from "../../assets/img/svg/xreadytorecycleicon.svg";
import RecycleIcon from "../../assets/img/svg/xrecycle.svg";
import RecyclingProcessIcon from "../../assets/img/svg/xrecyclingprocess.svg";
import BulkRackUpdate from "../../assets/img/svg/xbulkrackupdate.svg";
import { useAuth } from "react-oidc-context";
import { useAuth as useAuthName } from "../../auth/AuthContext";
import ExceptionBookAction from "../../assets/img/svg/xexceptionbook.svg";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import { getQcConfig } from "../../components/qcconfig/qcConfigService";

const Home = () => {
    const auth = useAuth;
    const navigate = useNavigate();
    const { displayName, tilename, userRoles, rolePagePermissions } = useAuthName();
    const { accessToken } = useAuthToken();
    const [isQcEnabled, setIsQcEnabled] = React.useState(false);

    const userRoleNames = (userRoles?.[0]?.roleName || "")
        .split(",")
        .map((role) => role.trim().toLowerCase())
        .filter(Boolean);

    const canAccessRoute = (route) => {
        if (!rolePagePermissions) return false; // hide until permissions have loaded

        const pagePermission = rolePagePermissions.find(
            (page) => (page.pathKey || "").toLowerCase() === (route || "").toLowerCase()
        );

        if (!pagePermission) return false;

        const allowedRoleNames = (pagePermission.allowedRoles || []).map((role) =>
            role.trim().toLowerCase()
        );
        return allowedRoleNames.some((role) => userRoleNames.includes(role));
    };

    useEffect(() => {
        const fetchQcConfig = async () => {
            try {
                const qcConfigValue = await getQcConfig({ accessToken });
                setIsQcEnabled(qcConfigValue === 1);
            } catch {
                setIsQcEnabled(false);
            }
        };

        if (accessToken) {
            fetchQcConfig();
        }
    }, [accessToken]);

    const handleNavigation = (route) => {
        const normalizedRoute = typeof route === "string" && route.trim().length > 0
            ? (route.startsWith("/") ? route : `/${route}`)
            : "/home";

        navigate(normalizedRoute);
    };
    if (auth.isAuthenticated) {
        //console.log(auth.user?.access_token, "HOMEPAGE");
    }

    const UserDetails = JSON.parse(localStorage.getItem("user"));
    const Loggedinusername = displayName || "";
    const tileNames = tilename;

    const ParentMenuName = tileNames.map((item) => item.ParentMenuName.trim().toLowerCase());
    const ChildMenus = tileNames.map((item) => item.ChildMenus.trim().toLowerCase().split(","));
    const submenus = ChildMenus.flat();


    const sections = [
        {
            title: "Intake & Shipment",
            items: [
                {
                    title: "Intake",
                    iconUrl: IntakeIcon,
                    description: "Scan new Books, Assign BID & Locations",
                    route: "/intake",
                },
                {
                    title: "Manifest Creation",
                    iconUrl: ManifestCreationIcon,
                    description: "Rack-Shelf mapping & manifest creation",
                    route: "/manifest-creation",
                },
                {
                    title: "Manifest Acceptance",
                    iconUrl: ManifestAcceptanceIcon,
                    description: "Rack-Shelf mapping & manifest Acceptance",
                    route: "/manifestacceptance",
                },
            ],
        },
        {
            title: "Processing",
            items: [
                {
                    title: "Cutting",
                    iconUrl: CuttingIcon,
                    description: "Prepare books for scanning",
                    route: "/cutting",
                },
                {
                    title: "Scanning",
                    iconUrl: ScanningIcon,
                    description: "High-quality digital scanning",
                    route: "/scanning",
                },
                ...(isQcEnabled
                    ? [
                        {
                            title: "QC",
                            iconUrl: QCIcon,
                            description: "Quality control with pass/ fail status",
                            route: "/qc",
                        },
                    ]
                    : []),
                {
                    title: "Bulk Rack Update",
                    iconUrl: BulkRackUpdate,
                    description: "Location update for Books",
                    route: "/bulkrack-update",
                },
                {
                    title: "Exception Book",
                    iconUrl: ExceptionBookAction,
                    description: "Return / Scrap Books",
                    route: "/exception-book-action",
                },
            ],
        },
        {
            title: "Delivery & Client",
            items: [
                {
                    title: "Client Rejected Books",
                    iconUrl: ClientIcon,
                    description: "Export reports & feedbacks",
                    route: "/clientqueue",
                },
                {
                    title: "Ready to Recycle",
                    iconUrl: ReadyToRecycleIcon,
                    description: "Rapid ISBN scanning for recycling",
                    route: "/ready-to-recycle",
                },
                {
                    title: "Recycling Process",
                    iconUrl: RecyclingProcessIcon,
                    description: "Recycle Manifest, Shipment, Certificate Of Destruction",
                    route: "/recycled",
                },
            ],
        },
    ];

    return (
        <div className="landing-page-container">
            <div className="landing-page-title-container">
                <h4>Welcome {Loggedinusername}!</h4>
                <span>Please select your station to begin...</span>
            </div>
            <div className="landing-page-body-container">
                {sections?.map((section, sectionIndex) => {
                    const visibleItems = section.items.filter(
                        (item) =>
                            submenus.includes(item.title.toLowerCase()) &&
                            canAccessRoute(item.route)
                    );

                    return (
                        ParentMenuName?.includes(section.title.toLowerCase()) &&
                        visibleItems.length > 0 && (
                            <div
                                key={sectionIndex}
                                className="landing-page-intake-container"
                            >
                                <div
                                    className="landing-page-intake-title-container"
                                >
                                    <h5>{section.title}</h5>
                                    <hr></hr>
                                </div>
                                <div className="landing-page-intake-cards-container">
                                    {visibleItems.map((item, itemIndex) => (
                                        <button
                                            key={itemIndex}
                                            onClick={() => handleNavigation(item.route)}
                                            data-track-route={item.route}
                                            data-track={`home-tile:${item.title}`}
                                            className="landing-page-intake-card"
                                        >
                                            <div className="landing-page-intake-card-title-container">
                                                <div className="landing-page-intake-card-title-icon">
                                                    <img src={item.iconUrl} alt="icons"></img>
                                                </div>
                                                <h6 className="landing-page-intake-card-title">
                                                    {item.title}
                                                </h6>
                                            </div>
                                            <p className="landing-page-intake-card-description">
                                                {item.description}
                                            </p>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )
                    );
                })}
            </div>
        </div>
    );
};

export default Home;
